"use client";

import { Component, type ErrorInfo, type ReactNode } from "react";
import { captureWebsiteException } from "@/lib/websiteErrors";

type Props = { children: ReactNode; message: string; retry: string };

/** All website roots use this boundary, including tools without an I18nProvider. */
export class WebsiteErrorBoundary extends Component<Props, { failed: boolean; attempt: number }> {
  state = { failed: false, attempt: 0 };

  static getDerivedStateFromError() { return { failed: true }; }

  componentDidCatch(error: Error, _info: ErrorInfo) {
    captureWebsiteException(error, { reason: "react_boundary" });
  }

  render() {
    if (this.state.failed) return <div role="alert" className="mx-auto my-12 max-w-xl rounded-2xl border border-border bg-card p-8 text-center">
      <p className="text-lg font-semibold">{this.props.message}</p>
      <button type="button" className="mt-5 rounded-xl bg-primary px-5 py-3 font-semibold text-primary-foreground"
        onClick={() => this.setState(state => ({ failed: false, attempt: state.attempt + 1 }))}>{this.props.retry}</button>
    </div>;
    return <div key={this.state.attempt} data-website-error-boundary>{this.props.children}</div>;
  }
}
